import React from 'react';
import cn from 'classnames';

const EditDesksPage = ({ className }) => {
  return <div className={cn(className)}>Edit Desks Page</div>;
};

export default EditDesksPage;
